import React from "react";
import { BedDouble, Bath, MapPin, CheckCircle2, ExternalLink } from "lucide-react";
import PageBanner from "../components/PageBanner";
import Reveal from "../components/Reveal";
import Seo from "../components/Seo";
import { CLOSED_SALES, CLOSED_STATS } from "../mock";

const ClosedSales = () => {
  return (
    <div>
      <Seo
        title="Recently Closed Sales | Roger Minner, Kennett Square PA Realtor"
        description="Browse a selection of homes recently sold by Roger Minner in Kennett Square, West Chester, Downingtown, and Chadds Ford, PA with Roger Minner. Listings updated across Chester County."
      />
      <PageBanner
        eyebrow="A Track Record You Can Trust"
        title="Closed Sales"
        subtitle="A selection of homes recently sold by Roger Minner Homes."
        image="https://images.unsplash.com/photo-1570129477492-45c003edd2be?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80"
      />

      {/* Stats */}
      <section className="bg-[#b6a4a7] py-14">
        <div className="max-w-[1100px] mx-auto px-6 grid grid-cols-2 md:grid-cols-4 gap-8">
          {CLOSED_STATS.map((s) => (
            <Reveal key={s.label} className="text-center">
              <p className="brand-title text-2xl sm:text-3xl md:text-4xl text-white">{s.value}</p>
              <p className="font-sans-el tracking-[0.2em] uppercase text-white/80 text-xs mt-2">{s.label}</p>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-[#f6f2ed] py-20 md:py-24">
        <div className="max-w-[1300px] mx-auto px-6">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {CLOSED_SALES.map((home) => (
              <Reveal key={home.id}>
                <a
                  href={home.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="property-card block rounded-sm overflow-hidden shadow-[0_18px_45px_-30px_rgba(58,55,54,0.4)] h-full flex flex-col group"
                >
                  <div className="relative overflow-hidden h-60">
                    <img src={home.img} alt={home.address} className="card-img w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#3a3736]/70 to-transparent" />
                    <span className="absolute top-4 left-4 flex items-center gap-1.5 bg-[#3a3736] text-white font-sans-el text-xs tracking-[0.15em] uppercase px-3 py-1.5 rounded-sm">
                      <CheckCircle2 size={13} /> Sold
                    </span>
                    <p className="absolute bottom-4 left-4 brand-title text-3xl text-white">{home.price}</p>
                  </div>
                  <div className="p-6 flex flex-col flex-1">
                    <h3 className="font-serif-el text-xl text-[#3a3736]">{home.address}</h3>
                    <p className="flex items-center gap-1.5 font-sans-el text-sm text-[#9a878b] mt-1">
                      <MapPin size={14} /> {home.city}
                    </p>
                    <div className="flex items-center gap-5 mt-4 text-[#4a4644]">
                      <span className="flex items-center gap-1.5 font-sans-el text-sm"><BedDouble size={16} className="text-[#b6a4a7]" /> {home.beds} Beds</span>
                      <span className="flex items-center gap-1.5 font-sans-el text-sm"><Bath size={16} className="text-[#b6a4a7]" /> {home.baths} Baths</span>
                    </div>
                    <div className="flex items-center justify-between mt-5 pt-4 border-t border-[#eae2d9]">
                      <p className="font-sans-el text-xs tracking-[0.2em] uppercase text-[#6f5f62]">
                        {home.represented}
                      </p>
                      <span className="flex items-center gap-1.5 font-sans-el text-xs tracking-[0.12em] uppercase text-[#9a878b] group-hover:text-[#6f5f62] transition-colors">
                        View on Zillow <ExternalLink size={13} />
                      </span>
                    </div>
                  </div>
                </a>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ClosedSales;
